import { useState, useEffect } from 'react';
import { fetchUserData } from '../services/userService';

export const useUserData = (userId) => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!userId) return;

    const loadUserData = async () => {
      setLoading(true);
      try {
        const data = await fetchUserData(userId);
        setUserData(data);
      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        setLoading(false);
      }
    };

    loadUserData();
  }, [userId]);

  return { userData, loading };
};
